/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { Input } from 'antd';

const AntDTextArea = Input.TextArea;

type AntDTextAreaProps = React.ComponentProps<typeof AntDTextArea>;

export type TextAreaProps = {
  allowClear: AntDTextAreaProps['allowClear'];
  count: AntDTextAreaProps['count'];
  rows: AntDTextAreaProps['rows'];
  maxLength: AntDTextAreaProps['maxLength'];
  style: AntDTextAreaProps['style'];
  dataTestId?: string;
  onChange?: AntDTextAreaProps['onChange'];
  onBlur?: AntDTextAreaProps['onBlur'];
  onFocus?: AntDTextAreaProps['onFocus'];
  onClick?: AntDTextAreaProps['onClick'];
  onPressEnter?: AntDTextAreaProps['onPressEnter'];
  value?: AntDTextAreaProps['value'];
};

export function TextArea({
  allowClear,
  count,
  rows,
  maxLength,
  style,
  dataTestId,
  onChange,
  onBlur,
  onFocus,
  onClick,
  onPressEnter,
  value,
}: TextAreaProps) {
  return (
    <Input.TextArea
      allowClear={allowClear}
      rows={rows}
      data-testid={dataTestId}
      count={count}
      maxLength={maxLength}
      style={style}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onClick={onClick}
      onPressEnter={onPressEnter}
      value={value}
    />
  );
}
